"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shoppingPortalSelectors = void 0;
const getCustomerId = (state) => state.customerId;
const getDeviceAttributes = (state) => state.deviceAttributes;
const getForwardedHost = (state) => state.forwardedHost;
const getInternalIpClass = (state) => state.internalIpClass;
const getLocale = (state) => state.locale;
const getMarketplaceId = (state) => state.marketplaceId;
const getPageNavNode = (state) => state.pageNavNode;
const getPageNaveStore = (state) => state.pageNavStore;
const getPageNavTemplate = (state) => state.pageNavTemplate;
const getPageType = (state) => state.pageType;
const getPageTypeId = (state) => state.pageTypeId;
const getRequestId = (state) => state.requestId;
const getSessionId = (state) => state.sessionId;
const getDeviceType = (state) => state.deviceType;
const getUbid = (state) => state.ubid;
const getI18nPreferences = (state) => state.i18nPreferences;
const getTrafficPolicies = (state) => state.trafficPolicies;
exports.shoppingPortalSelectors = {
    getCustomerId,
    getDeviceAttributes,
    getForwardedHost,
    getInternalIpClass,
    getLocale,
    getMarketplaceId,
    getPageNavNode,
    getPageNaveStore,
    getPageNavTemplate,
    getPageType,
    getPageTypeId,
    getRequestId,
    getSessionId,
    getDeviceType,
    getUbid,
    getI18nPreferences,
    getTrafficPolicies
};
